import { NotificationManager } from 'react-notifications';
import axios from 'axios';
import {
  IError,
  IGetManyBody,
  IIntegrationOptions,
  ILinkIntegrationBody,
  IPaymentMethod,
  IPaymentMethods,
} from 'src/store/api/paymentMethods/types';

const getMany = async ({ page, size, ...data }: IGetManyBody): Promise<IPaymentMethods | null> => {
  try {
    const res = await axios.post('api/v1/payment/system-group-form/integration', data, { params: { page, size } });

    return res.data;
  } catch (error) {
    NotificationManager.error("Can't fetch payment limits");

    return null;
  }
};

const linkIntegration = async (body: ILinkIntegrationBody) => {
  try {
    const res = await axios.put('api/v1/payment/system-group-form/integration', body);

    NotificationManager.success('Успешно');

    return res.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      NotificationManager.error((error.response.data as IError).message);
    } else {
      NotificationManager.error('Данные способ оплаты и провайдер несовместимы');
    }
  }
};

const getIntegrationByProviderId = async (providerId: number): Promise<Array<IIntegrationOptions> | null> => {
  try {
    const res = await axios.get(`api/v1/provider/${providerId}/payment/integration`);

    return res.data;
  } catch (error) {
    NotificationManager.error("Can't fetch integration by provider");

    return null;
  }
};

const getIntegrationsBySystemGroup = async (systemGroupId: number): Promise<IPaymentMethod | null> => {
  try {
    const res = await axios.get(`api/v1/payment/system-group-form/${systemGroupId}/integration`);

    return res.data;
  } catch (e) {
    console.error(e);

    return null;
  }
};

const editById = async (id: number, body: ILinkIntegrationBody) => {
  try {
    const res = await axios.post(`api/v1/payment/system-group-form/${id}/integration`, body);

    NotificationManager.success('Успешно');

    return res.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      NotificationManager.error((error.response.data as IError).message);
    } else {
      NotificationManager.error('Данные способ оплаты и провайдер несовместимы');
    }
  }
};

export const paymentMethodsApi = {
  getMany,
  linkIntegration,
  getIntegrationByProviderId,
  getIntegrationsBySystemGroup,
  editById,
};
